import { useRef, useEffect, useCallback, PropsWithChildren, FC, useState } from 'react'
import { Spin } from 'antd'
import DualAxes from '@/pages/Bmjy/components/components/DualAxes'
import CardContainer from '@/pages/Bmjy/components/components/CardContainer'

const tabsOptions = [
  {
    label: '按院', 
    value: 'ay',
    api: null
  }, 
  {
    label: '按所', 
    value: 'as',
    api: null
  }
]

type PropType = FC<PropsWithChildren<{
  updateTime: string
}>>

const Component: PropType = ({updateTime}) => {
  const [loading, setLoading] = useState(false)
  const [bnData, setBnData] = useState([])
  const [snData, setSnData] = useState([])
  const [zbData, setZbData] = useState([])
  const globalRef = useRef({
    params: {
      tab: '',
      depart: ''
    },
    loadTime: updateTime
  })

  const mockData = useCallback(() => {
    const data1 = []
    const data2 = []
    const data3 = []
    for(let i=0; i<12; i++) {
      data1.push({
        "label": i+ 1 + "所",
        "value": Math.floor(Math.random()*100)
      })
      data2.push({
        "label": i+ 1 + "所",
        "value": Math.floor(Math.random()*100)
      })
      data3.push({
        "label": i+ 1 + "所",
        value: Math.floor(Math.random()*100)
      })
    }
    setBnData(data1)
    setSnData(data2)
    setZbData(data3)
  }, [])
  
  // 获取图表数据
  const getColumnData = useCallback(async () => {
    const tabOption = tabsOptions.find(t => t.value === globalRef.current.params.tab)
    mockData()
    if(!tabOption || !tabOption.api) {
      return
    }

    const res = await tabOption.api()
    if(res.success) {
    }
  }, [mockData])

  // 获取统计数据
  const getTotal = useCallback(async () => {
    
  }, [])

  // 获取接口数据
  const getList = useCallback(async () => {
    setLoading(true)
    Promise.all([getColumnData(), getTotal()]).finally(() => {
      setLoading(false)
    })
  }, [getColumnData, getTotal])

  // 变更类型
  const handleTabChange = useCallback((value) => {
    globalRef.current.params = value
    getList()
  }, [getList])

  useEffect(() => {
    if(globalRef.current.loadTime !== updateTime) {
      globalRef.current.loadTime = updateTime
      getList()
    }
  }, [updateTime, getList])

  return (
    <Spin spinning={loading} wrapperClassName='full-spin'>
      <CardContainer
        tabs={tabsOptions}
        onTabChange={handleTabChange}
        title='各部门年度统计'
      >
        <div className='h-full pt-20'>
          <DualAxes
            bar1Label="本年委托单总数(万)"
            bar1Data={bnData}
            bar2Label='上年委托单总数(万)'
            bar2Data={snData}
            lineLabel='本年数占比去年总数(%)'
            lineData={zbData}
            barUnit='份'
          />
        </div>
      </CardContainer>
    </Spin>
  )
}

export default Component
